import {createAction} from 'redux-actions';

import {createAction as createNewAction} from 'web-app/util/redux/typed-action-helpers';
import * as actionTypes from 'web-app/react/constants/action-types';
import * as NewCreateAction from 'web-app/util/redux/famly-app-helpers';

const DOMAIN = 'SESSION_ACTIONS';

export const didReceiveAccessToken = createAction<string, string>(
    actionTypes.DID_RECEIVE_ACCESS_TOKEN,
    account => account,
);

export const fetchAccountCompleted = createAction(actionTypes.FETCH_ACCOUNT_SUCCESS, account => account);

export const {action: updateFreePackageBehavior} = NewCreateAction.createAction(
    `${DOMAIN}/UPDATE_FREE_PACKAGE_BEHAVIOR`,
    (freePackageBehavior: boolean, institutionId: string) => ({
        freePackageBehavior,
        institutionId,
    }),
);

export const {action: didSetPincode} = NewCreateAction.createAction(`${DOMAIN}/DID_SET_PINCODE`, () => ({}));

export const {action: closeSurvey} = createNewAction(`${DOMAIN}/CLOSE_SURVEY`, () => ({}));

export const {action: getQRSigninBehavior} = createNewAction(`${DOMAIN}/GET_QR_SIGNIN_BEHAVIOUR`, () => ({}));

export const {action: getQRSigninBehaviorSuccess} = createNewAction(
    `${DOMAIN}/GET_QR_SIGNIN_BEHAVIOUR_SUCCESS`,
    payload => payload,
);
